import { Component, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { Router, ActivatedRoute } from '@angular/router';
import { Actions } from '@ngrx/effects';
import { FormGroup, Validators, FormArray } from '@angular/forms';

import { ModuleConfiguration } from "../vocabulary.module.config";
import { ConceptWorkspaceModel } from '../models/ConceptWorkspaceModel';
import { TermModel } from "../models/TermModel";
import { PropertyModel } from "../models/PropertyModel";
import { RelationshipModel } from "../models/RelationshipModel";
import * as fromStore from '../store/reducers';
import * as workspaceActions from '../../pillar/workspace/store/actions';
import * as dashboardActions from '../../pillar/dashboard/store/actions';
import { AutoSaveFormBuilder } from '../../pillar/workspace/AutoSaveFormBuilder';
import { AbstractControl } from '@angular/forms/src/model';
import { Subject } from 'rxjs/Subject';
import * as vocabularyActions from '../store/actions';
import { AutoSaveFormGroup } from '../../pillar/workspace/AutoSaveFormGroup';
import { TermType } from "../models/TermType";
import { PropertyType } from "../models/PropertyType";
import { DeleteConceptVersionComponent } from './delete-concept-version.component';
import { MatDialog} from '@angular/material';
import { LookupModel } from '../../common/models/LookupModel';
import { CurrentUserService } from '../../security/services/CurrentUserService';

@Component({
  selector: 'brd-concept-workspace',
  templateUrl: './concept-workspace.component.html',
  styleUrls: ['./concept-workspace.component.scss']
})
export class ConceptWorkspaceComponent implements OnInit, OnDestroy {
  conceptWorkspace: ConceptWorkspaceModel;
  key: string;
  code:string;
  loading$: Observable<boolean>;
  errors$: Observable<string[]>;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  profileForm: FormGroup;
  canEdit=true;
  formArrayInitMethods = new Map<string, () => void>();
  termTypes: any[];
  propertyTypes: any[];
  valueSetCodes =new Array<LookupModel>();
  codeSystemVersions= new Array<LookupModel>();
  defaultValue = { key: '', description: '', isUniquePerParent: false };
  opened: boolean = false;

  constructor(private store: Store<any>,
    private router: Router,
    private formBuilder: AutoSaveFormBuilder,
    private actions$: Actions,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private changeDetectorRef: ChangeDetectorRef,
    private currentUserService: CurrentUserService) {}

  editPermission = 'VocabularyModule.CodeSystem:Edit';
  rootConceptCode = '100';
  externalRelationCode='2';
  ngOnInit() {
    this.termTypes = this.loadEnums(TermType);
    this.propertyTypes = this.loadEnums(PropertyType);
    this.route.params.take(1).subscribe(p => {
      this.key = p['key'];
      if (this.code) {
        this.store.dispatch(new vocabularyActions.GetSelctedConceptAction(ModuleConfiguration.moduleName, ConceptWorkspaceModel, { key: this.key, code: this.code }));
      }
    });
    this.route.queryParams.take(1).subscribe(p => {
      this.code = p['conceptCode'];
      if (this.key) {
        this.store.dispatch(new vocabularyActions.GetSelctedConceptAction(ModuleConfiguration.moduleName, ConceptWorkspaceModel, { key: this.key, code: this.code }));
      }
    });


    var updateTypes = [
      workspaceActions.updateModelType(ModuleConfiguration.moduleName, ConceptWorkspaceModel, 'conceptCode'),
      workspaceActions.updateModelType(ModuleConfiguration.moduleName, ConceptWorkspaceModel, PropertyModel),
      workspaceActions.updateModelType(ModuleConfiguration.moduleName, ConceptWorkspaceModel, RelationshipModel),
    ];
    var updateTermType = workspaceActions.updateModelType(ModuleConfiguration.moduleName, ConceptWorkspaceModel, TermModel);
    this.actions$
      .takeUntil(this.destroyed$)
      .filter(a => Boolean(updateTypes.find(t => a.type === workspaceActions.updateModelSuccessTypeByUpdateType(t))))
      .subscribe((a: workspaceActions.UpdateModelSuccessAction<ConceptWorkspaceModel, any>) => {
        a.payload.control.saveSuccess(a.payload.model);
      });
    this.actions$
      .takeUntil(this.destroyed$)
      .filter(a => Boolean(updateTypes.find(t => a.type === workspaceActions.updateModelErrorTypeByUpdateType(t))))
      .subscribe((a: workspaceActions.UpdateModelErrorAction<ConceptWorkspaceModel, any>) => {
        a.payload.action.payload.control.saveErrors(a.payload.action.payload.model, a.payload.errors);
      });

    this.actions$
      .takeUntil(this.destroyed$)
      .filter(a => Boolean(a.type === workspaceActions.updateModelSuccessTypeByUpdateType(updateTermType)))
      .subscribe((a: workspaceActions.UpdateModelSuccessAction<ConceptWorkspaceModel, TermModel>) => {
        a.payload.control.saveSuccess(a.payload.model);
        if (a.payload.model.isPreferred) {
          this.store.dispatch(new vocabularyActions.GetSelctedConceptAction(ModuleConfiguration.moduleName, ConceptWorkspaceModel, { key: this.key, code: this.code }));
        }

      });
    this.actions$
      .takeUntil(this.destroyed$)
      .filter(a => Boolean(a.type === workspaceActions.updateModelErrorTypeByUpdateType(updateTermType)))
      .subscribe((a: workspaceActions.UpdateModelErrorAction<ConceptWorkspaceModel, TermModel>) => {
        a.payload.action.payload.control.saveErrors(a.payload.action.payload.model, a.payload.errors);
      });


    var removeTermType = workspaceActions.removeModelSuccessType(ModuleConfiguration.moduleName, ConceptWorkspaceModel, TermModel);
    this.actions$.ofType(removeTermType)
      .takeUntil(this.destroyed$)
      .map((a: any) => a.payload)
      .subscribe((payload) => {
        payload.control.saveSuccess(payload.model);
        var termsFormArray = (this.profileForm.controls['terms'] as FormArray);
        var index = termsFormArray.controls.indexOf(payload.control);
        termsFormArray.removeAt(index);
      });

    var removePropertyType = workspaceActions.removeModelSuccessType(ModuleConfiguration.moduleName, ConceptWorkspaceModel, PropertyModel);
    this.actions$.ofType(removePropertyType)
      .takeUntil(this.destroyed$)
      .map((a: any) => a.payload)
      .subscribe((payload) => {
        payload.control.saveSuccess(payload.model);
        var propertiesFormArray = (this.profileForm.controls["properties"] as FormArray);
        var index = propertiesFormArray.controls.indexOf(payload.control);
        propertiesFormArray.removeAt(index);
      });

    var removeRelationshipType = workspaceActions.removeModelSuccessType(ModuleConfiguration.moduleName, ConceptWorkspaceModel, RelationshipModel);
    this.actions$.ofType(removeRelationshipType)
      .takeUntil(this.destroyed$)
      .map((a: any) => a.payload)
      .subscribe((payload) => {
        payload.control.saveSuccess(payload.model);
        var relationshipsArray = (this.profileForm.controls["relationships"] as FormArray);
        var index = relationshipsArray.controls.indexOf(payload.control);
        relationshipsArray.removeAt(index);
        this.codeSystemVersions.splice(index, 1);
        this.valueSetCodes.splice(index, 1);
      });


    this.store.select(fromStore.getConceptSelection)
      .takeUntil(this.destroyed$)
      .subscribe((v: ConceptWorkspaceModel) => {
        if (v) {
          this.conceptWorkspace = v;
          if (!this.profileForm) {
            this.initForms();
            this.initializeIndicators(v);
          } else {
            this.profileForm.controls.terms = this.formBuilder.array(this.conceptWorkspace.terms.map(a => this.initTerms()));
            this.profileForm.controls.terms.patchValue(this.conceptWorkspace.terms);
          }
          if (!v.canEdit || !this.currentUserService.hasPermission(this.editPermission)) {
            this.profileForm.disable();
            this.canEdit = false;
          }
          this.changeDetectorRef.markForCheck();
        }
      });

  }

  initForms(): void {
    this.profileForm = this.formBuilder.group({
      conceptCode: this.formBuilder.control('',
        Validators.required,
        null,
        this.destroyed$,
        (control) => {
          this.store.dispatch(new workspaceActions.UpdateModelAction(ModuleConfiguration.moduleName, ConceptWorkspaceModel, 'conceptCode', { key: this.conceptWorkspace.conceptVersionKey, model: control.value, control: control }));
        },
        this.changeDetectorRef),
      terms: this.formBuilder.array(this.conceptWorkspace.terms.map(a => this.initTerms())),
      properties: this.formBuilder.array(this.conceptWorkspace.properties.map(a => this.initProperties())),
      relationships: this.formBuilder.array(this.conceptWorkspace.relationships.map(a => this.initRelationships()))
    });

    this.formArrayInitMethods.set('terms', () => this.initTerms());
    this.formArrayInitMethods.set('properties', () => this.initProperties());
    this.formArrayInitMethods.set('relationships', () => this.initRelationships());

    this.profileForm.patchValue(this.conceptWorkspace);
    this.profileForm.markAsPristine();
  }
  loadEnums(enums: any) {
    let items: any[] = [];
    for (let key in enums) {
      var isValueProperty = parseInt(key, 10) >= 0;
      if (!isValueProperty) continue;
      items.push({ key: key, value: enums[key] });
    }
    return items;
  }

  initTerms() {
    var formGroup = this.formBuilder.group({
        key: [''],
        termType: ['', Validators.required],
        name: ['', Validators.required],
        isPreferred: [false, Validators.required],
        termKey: [''],
        cannotEdit: [''],
      },
      null,
      this.destroyed$,
      (control) => {
        this.store.dispatch(new workspaceActions.UpdateModelAction(ModuleConfiguration.moduleName, ConceptWorkspaceModel, TermModel, { key: this.conceptWorkspace.conceptVersionKey, model: control.value, control: control }));
      },
      this.changeDetectorRef);
    return formGroup;
  }

  initProperties() {
    var formGroup = this.formBuilder.group({
        key: [''],
        propertyType: ['', Validators.required],
        name: ['', Validators.required],
        value: ['', Validators.required]
      },
      null,
      this.destroyed$,
      (control) => {
        this.store.dispatch(new workspaceActions.UpdateModelAction(ModuleConfiguration.moduleName, ConceptWorkspaceModel, PropertyModel, { key: this.conceptWorkspace.conceptVersionKey, model: control.value, control: control }));
      },
      this.changeDetectorRef);
    return formGroup;
  }

  initRelationships() {
    var formGroup = this.formBuilder.group({
        key: [''],
        relatedConcept: ['', Validators.required],
        relationshipType: ['', Validators.required],
        isSourceConcept: [false, Validators.required],
        valueSetCode: [''],
        relationshipKey: [''],
        canDeleteRelationship: [''],
        codeSystemVersion:['']
      },
      null,
      this.destroyed$,
      (control) => {
        this.store.dispatch(new workspaceActions.UpdateModelAction(ModuleConfiguration.moduleName, ConceptWorkspaceModel, RelationshipModel, { key: this.conceptWorkspace.conceptVersionKey, model: control.value, control: control }));

      },
      this.changeDetectorRef);
    return formGroup;
  }

  removeTerms(form, terms: AutoSaveFormGroup, index) {
    terms.initializeRemove();
    this.store.dispatch(new workspaceActions.RemoveModelAction(ModuleConfiguration.moduleName, ConceptWorkspaceModel, TermModel, { key: this.conceptWorkspace.conceptVersionKey, model: terms.value, control: terms }));
  }

  removeProperties(form, properties: AutoSaveFormGroup, index) {
    properties.initializeRemove();
    this.store.dispatch(new workspaceActions.RemoveModelAction(ModuleConfiguration.moduleName, ConceptWorkspaceModel, PropertyModel, { key: this.conceptWorkspace.conceptVersionKey, model: properties.value, control: properties }));
  }

  removeRelationships(form, relationships: AutoSaveFormGroup, index) {
    relationships.initializeRemove();
    this.store.dispatch(new workspaceActions.RemoveModelAction(ModuleConfiguration.moduleName, ConceptWorkspaceModel, RelationshipModel, { key: this.key, model: relationships.value, control: relationships }));
  }


  addFormGroup(form, name) {
    form.controls[name].push(this.formArrayInitMethods.get(name)());
    if (name === 'relationships') {
      var index = this.profileForm.get('relationships').value.length;
      index = index - 1;
      this.valueSetCodes.push(this.defaultValue);
      this.codeSystemVersions.push(this.defaultValue);
      this.profileForm.get('relationships.' + index + '.valueSetCode')
        .valueChanges
        .takeUntil(this.destroyed$)
        .subscribe(value => {
          if (value === '') {
            value = this.defaultValue;
          }
          this.valueSetCodes[index] = value;
        });
      this.profileForm.get('relationships.' + index + '.codeSystemVersion')
        .valueChanges
        .takeUntil(this.destroyed$)
        .subscribe(value => {
          if (value === '') {
            value = this.defaultValue;
          }
            this.codeSystemVersions[index] = value;
        });
    }
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }

  back() {
    this.router.navigateByUrl('vocabulary-dashboard/' + this.key);
  }

  compareIds(id1: any, id2: any): boolean {
    return id1.toString() === id2.toString();
  }

  canEditTerm(index:any) {
    var a =this.profileForm.get('terms.' + index + '.cannotEdit').value;
    return a;
  }

  canDeleteRelationship(index: any) {
    var a = this.profileForm.get('relationships.' + index + '.canDeleteRelationship').value;
    return a;
  }

  isExternalRelation(index: any) {
    var a = this.profileForm.get('relationships.' + index + '.relationshipType').value.key===this.externalRelationCode;
    return a;
  }

  initializeIndicators(v: ConceptWorkspaceModel) {
    for (let i = 0; i < v.relationships.length; i++) {
      this.valueSetCodes.push(this.defaultValue);
      this.codeSystemVersions.push(this.defaultValue);
    }
  }
  deleteConcept() {
    this.dialog.open(DeleteConceptVersionComponent,
      {
        panelClass: 'customized-dialog',
        data:
        {
          name: this.getConceptDisplayName(),
          conceptVersionKey: this.conceptWorkspace.conceptVersionKey,
          codeSystemVersionKey: this.key
        },
        width: '324px'
      });
  }
  getConceptDisplayName() {
    return this.conceptWorkspace.terms.filter(term => term.termType === TermType.FullySpecifiedName && term.isPreferred)[0].name;
  }

  getPropertyType(index: any) {
    var isDate = this.profileForm.get('properties.' + index + '.propertyType').value === this.propertyTypes.find(element => element.value === 'Date').key ||
      this.profileForm.get('properties.' + index + '.propertyType').value === PropertyType.Date;
    return isDate;
  }

  onHistoryOpened() {
    this.opened = true;
  }

  onHistoryClosed() {
    setTimeout(() => {
      this.opened = false;
    }, 150);
  }

  getValueByKey(index: any, sources, key) {
    var value =this.profileForm.get(sources + '.' + index + '.' + key).value;
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/app/vocabulary/components/concept-workspace.component.ts